
<template>
  <div>
    <div class="detail-title mb-top20">
      <gj-area-title>买家关联订单</gj-area-title>
    </div>
    <gj-table
      :data="data"
      :columns="columns"
      :loading="loading"
      :pagination="pagination"
      :show-overflow="false"
      :adapt-height="false"
      :index="false"
      :isMinHeight="false"
      @page-change="$gjNoticeQuery"
      class="detail-table-remove-hover"
    >
      <template v-slot:orderId="{ row }">
        {{row.orderId}}
        <template v-if="row.fulfillmentChannel === 'AFN'">
          <gj-tag type="plain" :color="tagColors.blueDark">
            FBA
          </gj-tag>
        </template>
        <template v-if="row.fulfillmentChannel === 'MFN'">
          <gj-tag type="plain" :color="tagColors.greenDark">
            FBM
          </gj-tag>
        </template>
      </template>
       <template v-slot:picture="{ row }">
        <template v-for="item in row.items">
          <div :key="item.id">
            <a type="text" :href="item.asinUrl" target="_blank">
              <gj-image
                :src="item.imageUrl"
                :tag="row.testOrder ? '推' : null"
                :tag-color="{ color: '#ED6A0C', bdColor: '#F1924E' }"
              >
              </gj-image>
            </a>
          </div>
        </template>
      </template>
      <template v-slot:listingInfo="{ row }">
        <template v-for="item in row.items">
          <div :key="item.id" class="flex justify-between align-center">
            <div style="width: 85%">
              <gj-tooltip :text-line="1" class="item" :content="item.title" placement="top">
                <div class="text-ellipsis-1">{{item.title| defaultShow}}</div>
              </gj-tooltip>
              <el-row>
                <el-col :span="11">
                    <span>ASIN：</span>
                    <gj-link :href="item.asinUrl" target="_blank">{{item.asin | defaultShow}}</gj-link>
                    <gj-copy-icon v-if="isMeaningful(item.asin)" :content="item.asin"/>
                </el-col>
                <el-col :span="13">
                    <span>MSKU：</span><span>{{item.msku | defaultShow}}<gj-copy-icon v-if="isMeaningful(item.msku)" :content="item.msku"/></span>
                </el-col>
              </el-row>
            </div>
            <div style="width: 12%">
              数量: {{item.quantityOrdered | defaultShow}}
            </div>
          </div>
        </template>
      </template>
      <template v-slot:orderStatus="{ row }">
        <template v-for="(item, index) in saleOrderStatus">
          <template v-if="item.id === row.orderStatus">
            <gj-tag type="plain" :key="index" style="margin-left: 12px" :color="item">
              {{item.text}}
            </gj-tag>
          </template>
        </template>
      </template>
    </gj-table>
  </div>
</template>

<script>
import { getSaleOrderPage } from "@/api/sale";
import { saleOrderStatus } from "@/utils/options";
import { isMeaningful } from "@/utils/common";
import { queryMixin, responseMixin, isMeaningfulMixin, } from "@/minxins";
import { tagColors } from "@/components/tag/tag-colors";
export default {
    name: "sale-order-relation-order",
    mixins: [ queryMixin, responseMixin, isMeaningfulMixin],
    props: {
      buyerEmailKey: {
        required: true,
        type: String,
      },
      orderId: {
        required: true,
        type: String,
      }
    },
    data() {
      return {
        data: [],
        columns: [
          {id: 'orderId', header: '亚马逊订单编号', field: 'slot:orderId', minWidth: '150px', maxWidth: '100px', default: true},
          {id: 'picture', header: '图片', field: 'slot:picture', minWidth: '100px', maxWidth: '100px', default: true},
          {id: 'listingInfo', header: '商品信息', field: 'slot:listingInfo', minWidth: '480px', default: true},
          {id: 'orderTotal', header: '订单总金额', field: 'orderTotal', minWidth: '150px', default: true, align: 'right', prefix: 'currencySymbol'},
          {id: 'purchaseDate', header: '订购时间', field: 'purchaseDate', minWidth: '150px', default: true, help: '市场时间'},
          {id: "orderStatus", header: '订单状态', field: 'slot:orderStatus', minWidth: '150px', default: true}
        ],
        saleOrderStatus: saleOrderStatus,
        loading: false,
        tagColors
      }
    },
    methods: {
      $gjQuery() {
        this.loading = true;
        if (isMeaningful(this.buyerEmailKey)) {
          const params = {
            model: {
              buyerEmailKey: this.buyerEmailKey,
              filterOrderIds: [this.orderId],
              orderStatusList: ["PartiallyShipped", "Unfulfillable", "Shipped", "InvoiceUnconfirmed"]
            },
            ...this.queryPagination,
          };
          getSaleOrderPage(params)
            .then((result) => {
              this.data = result.records;
              this.pagination = this.getPagination(result);
            })
            .complete(() => {
              this.loading = false;
            });
        }else {
          this.loading = false;
        }
      },
      $gjQueryInit () {}
    }
  }
</script>

<style lang="scss" scoped>
  .mb-top20 {
    margin-top: 20px;
  }

  .detail-title {
    margin-bottom: 12px;
  }
</style>